import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function SelfAssessmentPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 5;
  const goToNextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };
  const goToPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  return <div className="w-full min-h-screen bg-[#f8f8f8] py-12 px-6" data-id="element-3100">
      <div className="max-w-4xl mx-auto" data-id="element-3101">
        {/* Back button */}
        <div className="mb-8" data-id="element-3102">
          <Link to="/assessment" className="flex items-center text-gray-600 hover:text-[#631bb7] transition-colors" data-id="element-3103">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-3104" />
            <span className="font-medium" data-id="element-3105">Back</span>
          </Link>
        </div>
        {/* Progress indicator */}
        <div className="mb-8" data-id="element-3106">
          <div className="flex justify-between items-center mb-2" data-id="element-3107">
            <span className="text-sm font-bold text-[#631bb7]" data-id="element-3108">
              Step {currentStep} of {totalSteps}
            </span>
            <span className="text-sm font-semibold text-gray-500" data-id="element-3109">
              {Math.round(currentStep / totalSteps * 100)}% Complete
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-3110">
            <div className="bg-[#631bb7] h-2 rounded-full transition-all duration-300" style={{
            width: `${currentStep / totalSteps * 100}%`
          }} data-id="element-3111"></div>
          </div>
        </div>
        {/* Assessment Content */}
        <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-3112">
          {currentStep === 1 && <div data-id="element-3113">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-3114">
                Let's start with the basics
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-3115">
                We'll ask you a few questions to understand your current setup.
              </p>
              <div className="space-y-6 mb-8" data-id="element-3116">
                <div className="border-2 border-gray-200 rounded-xl p-6" data-id="element-3117">
                  <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-3118">
                    Do you use a password manager?
                  </h3>
                  <div className="space-y-3" data-id="element-3119">
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3120">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3121" />
                      <span className="font-medium" data-id="element-3122">
                        Yes, for all my accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3123">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3124" />
                      <span className="font-medium" data-id="element-3125">
                        Yes, for some accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3126">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3127" />
                      <span className="font-medium" data-id="element-3128">
                        No, I remember them or write them down
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3129">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3130" />
                      <span className="font-medium" data-id="element-3131">
                        I'm not sure what that is
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-3132">
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-3133">
                  Continue
                </button>
              </div>
            </div>}
          {currentStep === 2 && <div data-id="element-3134">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-3135">
                Two-factor authentication
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-3136">
                This adds an extra layer of security to your accounts.
              </p>
              <div className="space-y-6 mb-8" data-id="element-3137">
                <div className="border-2 border-gray-200 rounded-xl p-6" data-id="element-3138">
                  <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-3139">
                    Do you use two-factor authentication (2FA)?
                  </h3>
                  <div className="space-y-3" data-id="element-3140">
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3141">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3142" />
                      <span className="font-medium" data-id="element-3143">
                        Yes, for all important accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3144">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3145" />
                      <span className="font-medium" data-id="element-3146">
                        Yes, for some accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3147">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3148" />
                      <span className="font-medium" data-id="element-3149">No, I don't use it</span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3150">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3151" />
                      <span className="font-medium" data-id="element-3152">
                        I'm not sure what that is
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-between" data-id="element-3153">
                <button onClick={goToPreviousStep} className="border-2 border-gray-300 text-[#111111] px-8 py-3 rounded-lg font-bold hover:border-[#631bb7] hover:text-[#631bb7] transition-colors" data-id="element-3154">
                  Back
                </button>
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-3155">
                  Continue
                </button>
              </div>
            </div>}
          {currentStep > 2 && <div data-id="element-3156">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-3157">
                Assessment Step {currentStep}
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-3158">
                This is a placeholder for step {currentStep} of the assessment.
              </p>
              <div className="flex justify-between" data-id="element-3159">
                <button onClick={goToPreviousStep} className="border-2 border-gray-300 text-[#111111] px-8 py-3 rounded-lg font-bold hover:border-[#631bb7] hover:text-[#631bb7] transition-colors" data-id="element-3160">
                  Back
                </button>
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-3161">
                  Continue
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}